module.exports = __webpack_public_path__ + "assets/img/32.61aabae6.png";